import React from 'react';
import { useAuth } from './AuthContext';
import ParticlesBackground from './ParticlesBackground';
import AppNavbar from './Navbar';
import './Momentum.css';

const TABS = [
    { id: 'vol-expansion', label: 'Vol Expansion',   endpoint: '/data/seasonality/vol-expansion' },
    { id: 'tlt',           label: 'TLT',             endpoint: '/data/seasonality/tlt' },
];

const Seasonality = () => {
    const { isAuthenticated, loading, error, setError, login } = useAuth();
    const [localEmail, setLocalEmail] = React.useState('');
    const [activeTab, setActiveTab] = React.useState('vol-expansion');
    const API_URL = process.env.REACT_APP_API_URL || '';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        await login(localEmail);
    };

    if (loading) {
        return (
            <div className="momentum-page">
                <header className="momentum-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content"><h1>Seasonality</h1></div>
                </header>
                <main className="momentum-main">
                    <div className="container"><p>Loading...</p></div>
                </main>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="momentum-page">
                <header className="momentum-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content"><h1>Seasonality</h1></div>
                </header>
                <main className="momentum-main">
                    <div className="container">
                        <div className="auth-section">
                            <h2>Subscriber Access Required</h2>
                            <p>Enter your Substack email to access seasonality analysis.</p>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={localEmail}
                                    onChange={(e) => setLocalEmail(e.target.value)}
                                    required
                                />
                                <button type="submit">Login</button>
                            </form>
                            {error && <p className="error-message">{error}</p>}
                            <iframe
                                src="https://machinaquanta.substack.com/embed"
                                title="Substack Subscription"
                                width="480"
                                height="320"
                                frameBorder="0"
                                scrolling="no"
                            />
                        </div>
                    </div>
                </main>
                <footer className="models-footer">
                    <div className="container">
                        <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        );
    }

    const currentTab = TABS.find(t => t.id === activeTab);

    return (
        <div className="momentum-page">
            <header className="momentum-header">
                <AppNavbar />
                <ParticlesBackground />
                <div className="header-content"><h1>Seasonality</h1></div>
            </header>

            <main className="momentum-main">
                <div className="container">
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
                        {TABS.map(tab => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                style={{
                                    padding: '8px 20px',
                                    borderRadius: '4px',
                                    border: '1px solid',
                                    cursor: 'pointer',
                                    fontWeight: activeTab === tab.id ? '700' : '400',
                                    background: activeTab === tab.id ? '#2a3a5a' : '#1a1a2e',
                                    color: activeTab === tab.id ? '#aaccff' : '#778',
                                    borderColor: activeTab === tab.id ? '#5588cc' : '#334',
                                    transition: 'all 0.15s',
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    <iframe
                        key={activeTab}
                        src={`${API_URL}${currentTab.endpoint}`}
                        title={currentTab.label}
                        scrolling="yes"
                        style={{
                            width: '100%',
                            height: '2200px',
                            border: 'none',
                            borderRadius: '4px',
                        }}
                    />
                </div>
            </main>

            <footer className="models-footer">
                <div className="container">
                    <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Seasonality;